module.exports = __webpack_public_path__ + "img/contact_point.63e2849f.png";